module.exports = __webpack_public_path__ + "img/2-3.d2bc52ff.jpg";